var map = {
	"./anm-card.png": 1164,
	"./arrow.png": 1165,
	"./arrow.webp": 1166,
	"./asset-1.svg": 1167,
	"./bg-exclusive.webp": 1168,
	"./boost.svg": 1169,
	"./brand-logo-cny.png": 1170,
	"./brand-logo-raya.webp": 1171,
	"./brand-logo.png": 108,
	"./brand-logo.webp": 1172,
	"./btn-black-m.webp": 1173,
	"./btn-blue-m-v2.png": 1174,
	"./btn-blue-m.png": 1175,
	"./btn-blue-m.webp": 1176,
	"./btn-white-m-v2.png": 1177,
	"./btn-white-m.png": 1178,
	"./default-bg.webp": 1179,
	"./deposit.webp": 1180,
	"./drop-more-btn.webp": 1181,
	"./duitnow.svg": 1182,
	"./eeziepay.svg": 1183,
	"./fcl.svg": 1184,
	"./fcl.webp": 1185,
	"./fpx-logo.svg": 1186,
	"./game-blue.png": 1187,
	"./game-img.png": 1188,
	"./game-white.png": 1189,
	"./global-language.svg": 1190,
	"./grabpay.svg": 1191,
	"./ifm-logo.svg": 1192,
	"./ifm-logo.webp": 1193,
	"./modal-bg.jpg": 1194,
	"./number-bg.webp": 1195,
	"./pagcor.svg": 1196,
	"./pagcor.webp": 1197,
	"./pool-bg.webp": 1198,
	"./promo-given.webp": 1199,
	"./side-bar-bg.png": 1200,
	"./spotlight-base.svg": 1201,
	"./spotlight.svg": 1202,
	"./tether.svg": 1203,
	"./title-asset.svg": 1204,
	"./tng.svg": 1205,
	"./winner.webp": 1206,
	"./withdrawal.webp": 1207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 167;